import { render, staticRenderFns } from "./OAuthButtons.vue?vue&type=template&id=06952d00&scoped=true"
import script from "./OAuthButtons.vue?vue&type=script&lang=js"
export * from "./OAuthButtons.vue?vue&type=script&lang=js"
import style0 from "./OAuthButtons.vue?vue&type=style&index=0&id=06952d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06952d00",
  null
  
)

export default component.exports